import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const sign_exclamation_point_1_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({
  iconColor,
  ...rest
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M2.7998,20.4997 L20.1998,20.4997 L11.4998,2.9997
    L2.7998,20.4997 Z M11.5,15.9997 L11.5,17.9997 M11.5,13.9997 L11.5,7.9997"
      />
    </svg>
  );
};
